import UiInput from '@/components/UI/UiInput.vue';
import UiSelector from '@/components/UI/UiSelector.vue';
import UiMultiSelector from '@/components/UI/UiMultiSelector.vue';
import UiCheckbox from '@/components/UI/UiCheckbox.vue';
import Btn from '@/components/UI/Btn.vue';
import UiTable from '@/components/UI/Table/ui-table.vue';

export default [UiInput, UiCheckbox, UiMultiSelector, Btn, UiTable, UiSelector];
